export const tokens = {
    gap: 20,
    marginTop: {
        mobile: 32,
        desktop: 48,
    },
};
